import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { USER_SSO } from './constants';
import { ssoSaga } from './sagas';

export const userSSO = (payload, onSuccess, onError) => {
  return createAction({
    type: USER_SSO,
    payload,
    meta: { onSuccess, onError, async: ssoSaga },
  });
};
